import { selectRoot } from 'react-formio';

export const selectForm = (name, state) => selectRoot(name, state).form;

export const selectFormError = (name, state) => selectRoot(name, state).error;
